module.exports = __webpack_public_path__ + "media/images/delete_ic-bed0b31668b9b33a61b847321b687f7c.svg";